import React, { useState } from 'react';
import {
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
  FloatingOverlay,
} from '@floating-ui/react';
import styled from 'styled-components';
import KubitTooltip from '../../KubitTooltip';
import { SecondaryButton } from '../../Button';
import { FloatingLayer } from '../../FloatingManager';
import CopyChartLinkButton from '../../Chart/ChartHeader/ChartHeaderIconActions/CopyChartLinkButton';
import { useChartContext } from '../../Chart/ChartContext';
import ReportEntityPermissionsWidgetPopover from './ReportEntityPermissionsWidgetPopover';

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px auto;
  height: 24px;
`;
const CopyContainer = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: unset;
  height: 100%;
  padding: 0;
  border: 1px solid currentColor;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const ShareButton = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  min-width: 0;
`;

const ShareReportPermissionsWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    metadata: { reportLink },
  } = useChartContext();

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(2), shift()],
    placement: 'bottom-end',
  });

  const click = useClick(context);
  const dismiss = useDismiss(context, {
    ancestorScroll: true,
  });
  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  return (
    <>
      <Container>
        <CopyContainer isOutlined={true}>
          <CopyChartLinkButton reportLink={reportLink} />
        </CopyContainer>
        <KubitTooltip
          content="Share Report"
          placement="bottom-end"
          disabled={isOpen}
          noOpenDelay={true}
        >
          <ShareButton
            ref={refs.setReference}
            {...getReferenceProps()}
            isOutlined={true}
          >
            Share
          </ShareButton>
        </KubitTooltip>
      </Container>
      {isOpen && (
        <FloatingLayer>
          <FloatingOverlay>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              {...getFloatingProps()}
            >
              <ReportEntityPermissionsWidgetPopover reportLink={reportLink} />
            </div>
          </FloatingOverlay>
        </FloatingLayer>
      )}
    </>
  );
};

export default ShareReportPermissionsWidget;
